import React from 'react';
import moment from 'moment';
import es from 'moment/locale/es';
import pt from 'moment/locale/pt';
import en from 'moment/locale/en-gb';
import { getUserLanguage } from '../Login/loginService';

const locales = {
    es: es,
    pt: pt,
    en: en
};
class AbstractsSearchForm extends React.Component {
    constructor(props) {
        super(props);
        const { user } = props;

        const language = getUserLanguage();
        moment.updateLocale(language, locales[language]);
        this.language = language;

        this.setStateFromQuery = this.setStateFromQuery.bind(this);
        this.START_DAY = new Date();
    }

    super() {
        return this;
    }

    handleFault = (error) => {
        var element = window.document.getElementById('expired');
        if (element) {
            element.remove();
        }
        alert(error.message);
    }

    handleUpdate = (action, data) => {
        //console.log(action, data);
    }

    setStateFromQuery = (query, comp) => {
        if (query) {
            let thestate = comp.state;
            thestate.nights = query.nights;
            thestate.rooms = query.rooms;
            thestate.totalRooms = query.rooms.length;
            thestate.checkIn = moment(query.checkInDate, 'DD/MM/YYYY');
            thestate.checkOut = moment(thestate.checkIn).add(query.nights, 'days'),
            thestate.loading = false;
            if (query.hotels) {
                thestate.hotels = query.hotels;
            }
            if (query.selectedSuggestion) {

                thestate.value = query.selectedSuggestion;
                thestate.selectedSuggestion = query.selectedSuggestion;
                thestate.valueLabel = query.selectedSuggestion.formattedName;
            }
            if (query.selectedMarket) {
                thestate.selectedMarket = query.selectedMarket;
            }
            comp.setState(thestate);
        }
    }

    /**
    * Dialog Handler
    */
    handleOpenDialog = () => {
        this.setState({ dialogOpen: true });
    };

    handleCloseDialog = value => {
        //si tengo value el usuario apreto confirmar
        if (value) {
            this.setState({
                rooms: value.rooms,
                totalRooms: value.totalRooms,
            });
        }
        this.setState({ dialogOpen: false });
    };

    handleClose = () => {
        this.props.onClose(this.state);
    };

    handleCancel = () => {
        this.props.onClose(null);
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        let thestate = this.state;
        if (nextProps.nights) {
            thestate.nights = nextProps.nights;
        }
        if (nextProps.arrival) {
            thestate.arrival = nextProps.arrival;
        }
        if (nextProps.checkOut) {
            thestate.checkOut = nextProps.checkOut;
        }
        this.setState(thestate);
    }

    handleTotalRoomChange = event => {
        let totalRooms = event.target.value;
        if (totalRooms > this.state.totalRooms) {
            let dif = totalRooms - this.state.totalRooms;
            let plusRooms = Array.from(Array(dif), x => ({
                adults: 2,
                kids: [],
                mealPlan: 'ALL',
            }));
            let rooms = this.state.rooms.concat(plusRooms);
            this.setState({ totalRooms, rooms });
        } else if (totalRooms < this.state.totalRooms) {
            let rooms = this.state.rooms.slice(0, totalRooms);
            this.setState({ totalRooms, rooms });
        }
    };

    handleAdultChange = (number, adults) => {
        let rooms = this.state.rooms;
        rooms[number].adults = adults;
        this.setState({ rooms });
    };

    handleKidsChange = (number, kids) => {
        let rooms = this.state.rooms;
        rooms[number].kids = Array.from(Array(kids), x => ({ age: 0 }));
        this.setState({ rooms });
    };

    handleKidsAgeChange = (number, numberKid, age) => {
        let rooms = this.state.rooms;
        rooms[number].kids[numberKid].age = age;
        this.setState({ rooms });
    };
}
export default (AbstractsSearchForm);


// WEBPACK FOOTER //
// ./src/components/SearchContent/AbstractSearchForm.js